export const spacing = {
  xxs: "4px",
  xs: "8px",
  sm: "16px",
  md: "24px",
  lg: "32px",
  xl: "40px",
  "2xl": "48px",
} as const;

const MENU_NAVIGATE_WIDTH = 200;
const MENU_NAVIGATE_GAP = 24;

export const layout = {
  pageContentWidth: "1198px",
  menuNavigateWidth: `${MENU_NAVIGATE_WIDTH}px`,
  menuNavigateGap: `${MENU_NAVIGATE_GAP}px`,
  menuNavigateOffset: `${MENU_NAVIGATE_WIDTH + MENU_NAVIGATE_GAP}px`,
} as const;

export const rounded = {
  xs: "4px",
  sm: "8px",
  md: "12px",
  lg: "16px",
  full: "50%",
} as const;

export const elevation = {
  lv1: "0px 2px 6px 0px #00000026",
  lv2: "0px 4px 10px 0px #00000026",
  lv3: "0px 8px 24px 0px #00000026",
  lv4: "rgba(0, 0, 0, 0.25) 0px 1px 2px 0px",
  lg: "0px 10px 15px -3px #0000001A, 0px 4px 6px -4px #1018281A",
  sm: "0px 1px 2px 0px #1018280D",
} as const;
